import React from 'react';
import { useLocation } from 'react-router-dom';

import { DesktopMenu } from './desktop-menu';

const Menu = () => {
  const params = useLocation();
  const [, path] = params.pathname.split('/');

  return (
    <div>
      <DesktopMenu path={path} />
    </div>
  );
};

export default Menu;
